import type {RouteRecordRaw} from "vue-router";
import {getCookie} from "@/shared/lib/utils/cookie";
import {localeUrlPattern} from "@/shared/lib/i18n";
import {applyUrlLocale} from "./applyUrlLocale";
import {routeName as mainName} from "./main";
import {routeName as cabinetTariffsName} from "./cabinet/tariffs";

export const routeName = 'PromocodeRedirect';

export const route: RouteRecordRaw = {
    name: routeName,
    // хвостовой /kk — язык отправителя для og-мета (см. default.conf); ?lang=kk работает как раньше
    path: `/promocode/:code/:lang(${localeUrlPattern})?`,
    // алиас: разбираем код из URL ровно здесь, сохраняем и сразу редиректим на тарифы
    redirect: (to) => {
        const code = String(to.params.code ?? '').replace(/\s+/g, '').toUpperCase().slice(0, 6);
        if (code) {
            localStorage.setItem('referralPromocode', code);
        }
        applyUrlLocale(to.params.lang);
        // авторизованного — в кабинетные тарифы; гостя — на тарифы лендинга, без навязывания логина
        return getCookie('GATEWAY')
            ? {name: cabinetTariffsName}
            : {name: mainName, hash: '#tariff'};
    },
};
